module.exports = __webpack_public_path__ + "img/moai.41d7daed.png";